<div class="flex h-full items-center justify-center px-6 py-20 md:px-12 lg:px-20">
  <div class="flex flex-col items-center justify-center gap-16">
    <app-empty-state [message]="errorMessage"></app-empty-state>
    <button [routerLink]="[backLink | localize]" pbutton="" type="button" class="p-button-outlined p-button">
      <span class="p-button-label">{{ 'errorpage.label.back' | translate }}</span>
    </button>
  </div>
</div>
